module.exports = __webpack_public_path__ + "site/img/122.be78aa27.jpg";